import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from "react";
const DEBOUNCE_MS = 300;
const QuantitySelector = ({ value, min = 0, max = 10, disabled = false, onChange, }) => {
    const lastClickRef = useRef(0);
    const handleChange = useCallback((delta) => {
        const now = Date.now();
        if (now - lastClickRef.current < DEBOUNCE_MS)
            return;
        lastClickRef.current = now;
        const newValue = value + delta;
        if (newValue < min || newValue > max || disabled)
            return;
        onChange(newValue);
    }, [value, min, max, disabled, onChange]);
    return (_jsxs("div", { className: "esim-addon__counter", children: [_jsx("button", { className: "esim-addon__counter-btn", onClick: () => handleChange(-1), disabled: disabled || value <= min, "aria-label": "Decrease quantity", type: "button", children: "\u2212" }), _jsx("span", { className: "esim-addon__counter-qty", children: value }), _jsx("button", { className: "esim-addon__counter-btn", onClick: () => handleChange(1), disabled: disabled || value >= max, "aria-label": "Increase quantity", type: "button", children: "+" })] }));
};
export default QuantitySelector;
